<div class="loading">
    <img src="https://eureka2022.s3.ap-south-1.amazonaws.com/Infinity.gif" alt="">
</div>
